const actionItemStatus = {
    open: 'Open',
    closed: 'Closed',
    onHold: 'OnHold',
    urgent: 'Urgent'
};

export default actionItemStatus;